import {useTranslation} from 'react-i18next';
import Text from '../../common/component/Text';
import TextButton from '../../common/component/TextButton';
import {showAuthModal} from '../../common/function';

export interface IProps {
  textKey: string;
  onClickLogin?: () => void;
  textClassName?: string;
}

export default function NoLogin({
  textKey,
  onClickLogin,
  textClassName,
}: IProps) {
  const {t} = useTranslation();

  return (
    <div className="fixed inset-0 h-full flex-center flex-col text-center">
      <Text className={cn('s16-regular-grey08', textClassName)}>
        {t(textKey)}
      </Text>
      <div className="mt-24">
        <TextButton
          className="btn-grey-08 px-24 h-39"
          textClassName="s14-bold-grey08"
          onClick={() => {
            showAuthModal({titleType: 'loginButton'});
            onClickLogin?.();
          }}
        >
          {t('common_login')}
        </TextButton>
      </div>
    </div>
  );
}
